$(document).ready(function(){
  var h = $(".section-image-columns .wave-top img").height();
  $(".section-image-columns .wave-top img").css("margin-bottom", -h/2+"px");
  //$("shopify-payment-terms").appendTo(".product-detail__title-price");

  setTimeout(function(){
    var h = $(".gallery-masonry__wrapper .item-block-inner.hover-zoomout").parent().height();
    $(".gallery-masonry__wrapper .item-block-inner.hover-zoomout").css("height", h+"px");
  }, 1000);
});
$(window).resize(function(){
  var h = $(".section-image-columns .wave-top img").height();
  $(".section-image-columns .wave-top img").css("margin-bottom", -h/2+"px");

  setTimeout(function(){
    var h = $(".gallery-masonry__wrapper .item-block-inner.hover-zoomout").parent().height();
    $(".gallery-masonry__wrapper .item-block-inner.hover-zoomout").css("height", h+"px");
  }, 1000);
});

$(document).ready(function() {  
	$('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',
      
      callbacks: {
  
          open: function() { 
              $('body').css('overflow', 'hidden');  
          },                                        
  
          close: function() {                       
              $('body').css('overflow', '');  
              $("#newsletter-popup").removeClass("animate__close");
              $(".gallery-popup-video video").prop('muted', true);
          },  
        
          beforeClose: function() {
              $(".gallery-popup-video .popup-control .icon-volumn").addClass('muted');
          }
      }
	});

  $("#newsletter-popup .mfp-close").click(function(){
    $(this).parent().addClass("animate__close");
    $.magnificPopup.close();
  });
  $(".gallery-popup-video .popup-title svg").click(function(){
    $.magnificPopup.close();
  });

  $(".gallery-popup-video .popup-control .icon-volumn").click(function(){
    var video = $(this).parents(".gallery-popup-video").find("video");
    if( video.prop('muted')){
      $(this).removeClass("muted");
      video.prop('muted', false);
    }else{
      $(this).addClass("muted");
      video.prop('muted', true);
    }
  });

  $("#newsletter-success-popup .btn-close").click(function(){
    $(this).parents("#newsletter-success-popup").addClass("animate__close");
    $.magnificPopup.close();
  });
  
  // var search = $(location).attr('search');
  // if(search == '?customer_posted=true'){
  //   $.magnificPopup.open({
  //     items: {
  //       src: '#newsletter-success-popup' 
  //     },
  //     type: 'inline',
  //     callbacks: {
  //       open: function() {                        
  //             $('body').css('overflow', 'hidden');  
  //       },                                        
  //       close: function() {                       
  //             $('body').css('overflow', '');  
  //             $("#newsletter-success-popup").removeClass("animate__close");
  //       }, 
  //     }
  //   });
  // }

  $(".gallery-popup-video .popup-control .icon-share-svg").click(function(){
    $(this).parent().find(".article--share-icon").toggle();
  });

  $(".gallery-masonry__wrapper .item-block-inner.hover-zoomout").click(function(){
    $(this).find(".popup-with-zoom-anim").trigger("click");
  });

  $(".size-chart tab h4").click(function(){
    $(this).parent().find(".content").slideToggle();
  });

  $(".slide-video .line-3 .button").click(function(){
    $(this).parents(".slide-video").find("video").trigger("play").attr("controls", "true");

    if(window.innerWidth >= 768 || !$(this).parents(".slick-slider-dots-light-xs").length > 0){
        $(this).parents(".overlay-type").hide();
    }

    $(this).parents(".slide-video").find(".video-wrapper img").hide();
    $(this).parents(".slide-video").find(".video-wrapper .section-background-video--inline").hide();
    $(this).parents(".slide-video").find("iframe").show();
    $(this).parents(".slide-video").find("iframe").get(0).src += "&autoplay=1";
  });

  $(".main-nav__parent").click(function(){
    $("a[href='#page-menu']").addClass("hide");
    $(".page-menu__back").removeClass("hide");  
  });
  $(".page-menu__back").click(function(){
    $("a[data-revert-back]").trigger("click");
    $("a[href='#page-menu']").removeClass("hide");
    $(".page-menu__back").addClass("hide");
  });
});

$(function () {
    $(".gallery-masonry__wrapper .item-block").slice(0, 39).show();
    $(".gallery-button-loadmore .btn-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".gallery-masonry__wrapper .item-block:hidden").slice(0, 39).slideDown();
        if ($(".gallery-masonry__wrapper .item-block:hidden").length == 0) {
            $(".gallery-button-loadmore .btn-loadmore").fadeOut('slow');
        }
    });
});

$(function () {
  $('.klaviyo_form_trigger--push_me').on('click', function (){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'VRThrZ']);
  });
  $('.klaviyo_form_trigger').on('click', function (){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'QYLeRu']);
  });
});

$(document).ready(function(){
  if($(window).width() < 768){
    $('.section-featured-collection .product-list1').slick({
      infinite: true,
      arrows: false,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1
    });
    $('.image-columns__wrapper').slick({
      infinite: true,
      centerMode: true,
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    $('.section-image-columns .gallery-masonry__mobile-carousel').slick({
      infinite: true,
      centerMode: true,
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
});

$(document).mouseup(function(e) {
    var container = $("#menu-tier-2");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $("[aria-controls='menu-tier-2']").trigger("click");
    }
});
$(".contains-mega-menu").click(function(){
  if($(this).find("a.has-children").hasClass("expanded")){
    setTimeout(function(){
      $("#menu-tier-2").slideUp();
      $(".contains-mega-menu a.has-children").removeClass("expanded");
      $(".contains-mega-menu a.has-children").removeAttr("aria-controls");
    }, 100);
    return false;
  }
});

$(function() {
    var colCount = 0;
    $('.size-chart table tr:nth-child(1) td').each(function () {
        if ($(this).attr('colspan')) {
            colCount += +$(this).attr('colspan');
        } else {
            colCount++;
        }
    });
    $('.size-chart table tr td').css('width', 100/colCount + '%');
});